// Rarity utility functions and constants

// Import rarity images
import commonGem from '../assets/images/rarity/common.png';
import uncommonGem from '../assets/images/rarity/uncommon.png';
import rareGem from '../assets/images/rarity/rare.png';
import epicGem from '../assets/images/rarity/epic.png';
import legendaryGem from '../assets/images/rarity/legendary.png';

export type RarityType = 'Common' | 'Uncommon' | 'Rare' | 'Epic' | 'Legendary';

// Rarity images mapping
export const rarityImages: Record<RarityType, string> = {
  Common: commonGem,
  Uncommon: uncommonGem,
  Rare: rareGem,
  Epic: epicGem,
  Legendary: legendaryGem,
};

// Fallback colors (for backwards compatibility or when images fail to load)
export const rarityColors: Record<RarityType, string> = {
  Common: '#43a047',    // green
  Uncommon: '#1e88e5',  // blue  
  Rare: '#ff9800',      // orange
  Epic: '#8e24aa',      // purple
  Legendary: '#ffd600', // yellow
};

// Get rarity image with fallback to color
export const getRarityImage = (rarity: string): string | null => {
  const normalizedRarity = rarity as RarityType;
  return rarityImages[normalizedRarity] || null;
};

// Get rarity color
export const getRarityColor = (rarity: string): string => {
  const normalizedRarity = rarity as RarityType;
  return rarityColors[normalizedRarity] || '#95a5a6';
};

// Rarity order for sorting (highest to lowest)
export const rarityOrder: Record<RarityType, number> = {
  Legendary: 0,
  Epic: 1,
  Rare: 2,
  Uncommon: 3,
  Common: 4,
};

// Get rarity sort value
export const getRaritySortValue = (rarity: string): number => {
  const normalizedRarity = rarity as RarityType;
  return rarityOrder[normalizedRarity] ?? 999;
}; 